import { useQuery } from '@tanstack/react-query';
import { getOrderTimeline } from '../orders.api';

export function useOrderTimeline(orderNumber: string) {
  return useQuery({
    queryKey: ['orders', 'timeline', orderNumber],
    queryFn: () => getOrderTimeline(orderNumber),
    staleTime: 30 * 1000,
  });
}
